import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { IntoxicationReadData, IntoxicationReadLabel } from '../intoxicationSchemas';
import type { OsasZorgDomeinReferralCustomControlData } from './osasZorgDomeinReferralSchema';
import {
    type OsaReferralReadData,
    type OsasReferralReadLabel,
    osasReferralReadSchema,
} from '../osasReferralSchemas/osasReferralReadSchema';

export const osasZorgDomeinReferralReadSchema: TypedReadSchema<
    OsasZorgDomeinReferralReadKey | keyof IntoxicationReadData,
    OsasZorgDomeinReferralReadLabel | IntoxicationReadLabel
>[] = osasReferralReadSchema.map((section) => {
    if (section.sectionTitle === 'Verwijzing') {
        return { ...section, items: [{ key: 'referrer', label: 'Verwijzer' }, ...section.items] } as TypedReadSchema<
            OsasZorgDomeinReferralReadKey,
            OsasZorgDomeinReferralReadLabel
        >;
    }

    return section;
});
export type OsasZorgDomeinReferralReadData = OsasZorgDomeinReferralCustomControlData &
    OsaReferralReadData & { referrer: string[] };
export type OsasZorgDomeinReferralReadLabel = OsasReferralReadLabel | 'Verwijzer';
export type OsasZorgDomeinReferralReadKey = keyof OsasZorgDomeinReferralReadData;
